/**
 * iOS Safari only raises the keyboard for a focus() that happens inside a
 * user gesture — a route change breaks that chain, so the form's autoFocus
 * lands silently. Focusing a throwaway input synchronously in the tap that
 * navigates opens the keyboard; the title field then inherits it.
 * Call in the same handler as navigate('/log/…/new'), or as the tap that
 * swaps a read view for an editor that loads lazily (client pages).
 */
export function primeKeyboard() {
  const decoy = document.createElement('input')
  decoy.type = 'text'
  decoy.setAttribute('aria-hidden', 'true')
  // 16px stops iOS from zooming; fixed + transparent keeps it invisible.
  decoy.style.cssText = 'position:fixed;top:0;left:0;opacity:0;height:1px;font-size:16px'
  document.body.appendChild(decoy)
  decoy.focus()
  // The destination form ADOPTS the focus and retires the decoy the moment
  // it mounts (see SessionFormPage) — removing a still-focused decoy on a
  // timer closed the keyboard before slow mounts could take over (Charles,
  // 2026-08-06: keyboard wasn't opening). The timer is only a safety net.
  window.__cdmKbDecoy?.remove()
  window.__cdmKbDecoy = decoy
  setTimeout(() => {
    if (window.__cdmKbDecoy === decoy) {
      decoy.remove()
      window.__cdmKbDecoy = null
    }
  }, 4000)
}

/** Called by the screen that owns the real input, right after focusing it. */
export function adoptKeyboard() {
  window.__cdmKbDecoy?.remove()
  window.__cdmKbDecoy = null
}
